import axios from "axios";
import Head from "next/head";
import { useEffect, useState } from "react";
import mixpanel from "@/utils/mixpanel";
import DATA from "./short-free-content.json";
import { DataItem, schema } from "@/types/marketingPages/Short_Free_DT";
import Image from "next/image";
import { formatDate, formatTime } from "@/marketingUtils/dateTimeParser";
import { useRouter } from "next/router";
import Link from "next/link";
import MarketingNewPaidForm from "@/components/marketingPages/MarketingNewPaidForm";

export async function getServerSideProps(context: {
  params: { id: string; slug: string };
}) {
  const { id, slug } = context.params;
  const pageData = (DATA as schema)[slug];
  try {
    const { data } = await axios.get(
      `${process.env.NEXT_PUBLIC_BASE_API}masterclasses/${id}`,
      {
        headers: {
          "Accept-Encoding": "gzip",
        },
      }
    );

    return {
      props: {
        masterclass: data.data,
        slug: slug,
        pageData: pageData,
      },
    };
  } catch (err) {
    return {
      props: {
        masterclass: {},
      },
    };
  }
}

export default function ShortFree({
  masterclass,
  slug,
  pageData,
}: {
  masterclass: any;
  slug: string;
  pageData: DataItem;
}) {
  const isConclave = slug === "astro-conclave";
  const slots = masterclass?.slots;
  const activeSlot = slots?.find((slot: any) => slot.active);
  const activeTime = formatDate(activeSlot?.startDateTime);
  const activeDate = formatTime(activeSlot?.startDateTime);
  const router = useRouter();

  const isTaboola = router.query.source === "Taboola";
  const adid = router.query.adid
    ? pageData?.ad_array?.[Number(router.query.adid)]
      ? Number(router.query.adid)
      : null
    : null;

    const [price, setPrice] = useState<PriceObj>({
      price: masterclass.price,
      discountedPrice: "0",
      workshopTitle: masterclass.title,
      source: "free_masterclass",
    });

  useEffect(() => {
    mixpanel.track("marketing_page", {
      page_location: window.location.href,
      page_referrer: document.referrer,
      masterclass: masterclass?.title,
      type: "free",
      landing_page: "short-free",
      masterclassId: masterclass?.id,
      platform: "astrolearn",
    });
  }, []);
  return (
    <>
      <Head>
        <title>{pageData?.title}</title>
        <meta
          name={pageData?.meta.name}
          content={pageData?.meta.content}
          key={pageData?.meta.key}
        />
      </Head>
      <main className="max-w-screen mx-auto !select-none font-sans ">
        {/* ----- phone view ----- */}
        <div className="block md:hidden">
          <div className=" flex items-center overflow-hidden justify-center relative">
            <div className="w-[150%] bg-[#FFF3E4] absolute h-full rounded-b-[45%] -z-20  overflow-hidden">
              <img
                src="/astro/astro-chakra.png"
                className="w-[50%] sm:max-w-[280px] ml-[27%] mt-[25%] animate-spin-slow absolute -z-10 xs:left-[24%] xs:top-[20%] xs:ml-0 xs:mt-0 sm:left-[35%]"
              />
              <img
                src={`/${slug}/teacher.webp`}
                className="w-[70%] sm:max-w-[450px] max-xs:mt-52 max-xs:ml-24 z-10 absolute xs:top-[32%] xs:left-[15%] sm:left-[27%]"
              />
            </div>
            <div className="flex justify-center items-center flex-col">
              <img
                src="/astro/short_free_astroLogo.svg"
                className="pb-2 pt-4 h-[55px]"
              />
              <div className="px-6 text-center">
                <h1
                  className="text-center font-sans font-bold text-2xl text-[#2F327D] xs:text-2xl"
                  dangerouslySetInnerHTML={{
                    __html: adid
                      ? pageData?.ad_array
                        ? pageData?.ad_array?.[adid].heading
                          ? pageData?.ad_array?.[adid].heading
                          : pageData?.heading
                        : pageData?.heading
                      : pageData?.heading,
                  }}
                ></h1>
                <p
                  className="text-[#464646] xs:text-lg xs:mt-3"
                  dangerouslySetInnerHTML={{
                    __html: adid
                      ? pageData?.ad_array
                        ? pageData?.ad_array?.[adid].sub_heading
                          ? pageData?.ad_array?.[adid].sub_heading
                          : pageData?.sub_heading
                        : pageData?.sub_heading
                      : pageData?.sub_heading,
                  }}
                />

                <div className="flex flex-col justify-center items-center mt-[3px] h-[380px] sm:h-[420px]"></div>
              </div>
            </div>
          </div>
          <div className="flex gap-3 justify-center items-center w-fit bg-[#FFF3E4] rounded-lg mt-1 mx-auto px-2 py-1">
            <Image
              src="/ui/side-navbar/review.svg"
              alt="review"
              width={120}
              height={30}
            />
            <div>
              <Image
                src="/stars.svg"
                width={100}
                height={20}
                alt="stars"
                className="mx-auto"
              />
              <p className="font-semibold mt-0.5 max-xl:text-xs">
                8.5k+ reviews (4.9 of 5)
              </p>
            </div>
          </div>
          <div className="flex gap-2 w-fit mx-auto my-2 text-center font-semibold text-sm">
            <div className="bg-[#FBE0C7] flex justify-center items-center gap-2 px-4 py-2 rounded-md min-w-[152px]">
              <Image
                src="/ui/side-navbar/shortPageIcon.svg"
                height={22}
                width={22}
                alt="calender-icon"
              />
              <p>{activeTime}</p>
            </div>
            <div className="bg-[#FBE0C7] flex flex-row justify-center items-center gap-2 text-center px-4 py-2 rounded-md min-w-[152px]">
              <Image
                src="/ui/side-navbar/shortPageIcon2.svg"
                height={22}
                width={22}
                alt="calender-icon"
              />
              <p>{activeDate}</p>
            </div>
          </div>
          <MarketingNewPaidForm
                price={price}
                masterclass={masterclass}
                isFreeMc={true}
                type="normal"
                showEmailField={false}
                showNameField={false}
                showPhoneLabel={false}
                slug={slug}
                outerContainerClass="!py-3"
                customCtaText="Register Now for Free"
                btnClass="!bg-[#FF7700]"
                formHeading="Enter Your Phone Number"
              />
        </div>

        {/* ----- tab & desktop view ----- */}
        <div className="max-md:hidden overflow-hidden relative !select-none ">
          <Image
            src="/astro/short_free_astroLogo.svg"
            width={270}
            height={50}
            alt="logo"
            className="max-lg:w-[170px] pt-10 pl-10 object-contain"
          />
          <div className="flex items-center justify-center">
            <div className="w-[150%] bg-[#FFF3E4] absolute -z-20  h-[95%] top-0 rounded-b-[45%] overflow-hidden">
              <Image
                width={478}
                height={438}
                src="/astro/astro-chakra.png"
                alt="decorative"
                className="object-contain w-[350px] lg:w-[450px] xl:w-[500px] absolute top-[25%] left-[17%] animate-spin-slow lg:left-[20%] xl:top-[10%] xl:left-[20%] "
              />
              <img
                src={`/${slug}/teacher.webp`}
                width={679}
                height={668}
                alt="teacher"
                className={`object-contain w-[380px] lg:w-[530px] left-[17%] xl:left-[19%] bottom-0 absolute ${
                  isConclave && " bottom-[40%]"
                }`}
                style={{
                  zIndex: 10,
                }}
              />
            </div>

            <div className="w-[48.5%] flex flex-col justify-center items-center relative max-xl:pt-[91px] xl:pt-[70px]">
              <img
                src="/astro/krish.png"
                width={479}
                height={468}
                className="mt-36 w-[100%] max-xl:mt-40 max-2xl:w-[100%] scale-125 max-lg:w-[100%] 2xl:w-[75%] 2xl:mt-6 opacity-0"
                draggable={false}
              />
            </div>

            <div className="w-[48.5%] mx-auto">
              <h1
                className="font-bold text-[#2F327D] text-3xl lg:text-5xl lg:leading-[50px] text-center"
                dangerouslySetInnerHTML={{
                  __html: adid
                    ? pageData?.ad_array
                      ? pageData?.ad_array?.[adid].heading
                        ? pageData?.ad_array?.[adid].heading
                        : pageData?.heading
                      : pageData?.heading
                    : pageData?.heading,
                }}
              ></h1>
              <p
                className="mt-2 text-lg lg:mt-5 lg:text-xl text-center"
                dangerouslySetInnerHTML={{
                  __html: adid
                    ? pageData?.ad_array
                      ? pageData?.ad_array?.[adid].sub_heading
                        ? pageData?.ad_array?.[adid].sub_heading
                        : pageData?.sub_heading
                      : pageData?.sub_heading
                    : pageData?.sub_heading,
                }}
              />
              <div className="max-w-[500px] mx-auto mt-4 shadow-md">
                <MarketingNewPaidForm
                  isOpen={true}
                  price={price}
                  masterclass={masterclass}
                  isFreeMc={true}
                  type="modal"
                  slug={slug}
                  customCtaText="Register Now for Free"
                  btnClass="!bg-[#FF7700]"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="max-md:hidden">
          <div className="w-[50%] -mt-32 lg:-mt-28">
            <div className="flex gap-2 xl:gap-8 -mt-20 lg:-mt-12 xl:-mt-16 z-30 relative text-center font-semibold text-lg xl:text-xl mx-auto w-fit">
              <div className="bg-[#FBE0C7] flex justify-center items-center gap-2 px-4 py-1 rounded-md min-w-[152px] xl:ml-10 lg:py-4 lg:px-8">
                <Image
                  src="/ui/side-navbar/shortPageIcon.svg"
                  height={28}
                  width={28}
                  alt="calender-icon"
                />
                <p>{activeTime}</p>
              </div>
              <div className="bg-[#FBE0C7] flex justify-center items-center gap-2 text-center p-4 rounded-md min-w-[152px] lg:py-4 lg:px-8">
                <Image
                  src="/ui/side-navbar/shortPageIcon2.svg"
                  height={28}
                  width={28}
                  alt="calender-icon"
                />
                <p>{activeDate}</p>
              </div>
            </div>
          </div>

          <div className="w-[48%] relative z-10">
            <div className="flex gap-3 justify-center items-center w-fit bg-[#FFF3E4] rounded-lg mt-3 mx-auto px-2 py-1">
              <Image
                src="/ui/side-navbar/review.svg"
                alt="review"
                width={120}
                height={30}
              />

              <div>
                <Image
                  src="/stars.svg"
                  width={100}
                  height={20}
                  alt="stars"
                  className="mx-auto"
                />
                <p className="font-semibold mt-0.5 max-xl:text-xs">
                  8.5k+ reviews (4.9 of 5)
                </p>
              </div>
            </div>
          </div>
        </div>
        {isTaboola && (
          <div className="fixed bottom-0 h-6 bg-orange-100 w-full flex items-center justify-center max-md:hidden">
            <p className="text-xs text-center">
              © Astrolearn.co | Connect at: solutions@astrolearn.co |{" "}
            </p>
            <Link href="/privacy-policy">
              <p className="text-xs text-center underline">Privacy Policy</p>
            </Link>
          </div>
        )}
      </main>
    </>
  );
}
